export const NOTIFICATION_GUESTLINE_ORDER_CREATED = 'guestline_order_created'
export const NOTIFICATION_GUESTLINE_ORDER_GUEST_ADDED = 'guestline_order_guest_added'
export const NOTIFICATION_GUESTLINE_ORDER_GUEST_REMOVED = 'guestline_order_guest_removed'
export const NOTIFICATION_GUESTLINE_ORDER_CANCELLED = 'guestline_order_cancelled'
export const NOTIFICATION_GUESTLINE_UNASSIGEND_ORDER_CREATED = 'guestline_unassigned_order_created'

export const NOTIFICATION_ACTION_VIEW_ORDER = 'view_order'
export const NOTIFICATION_ACTION_DOWNLOAD_REPORT = 'download_report'
